import React from "react"
import "./MainBackground.css"

const MainBackground = ({ children }) => {
  return <div className="main-background">{children}</div>
}

export default MainBackground
